import React, { useEffect, useRef, useState } from "react";
import { Button, FormControl, FormGroup } from "react-bootstrap";
import { PARTICIPANT_PHOTO } from "../../constants";
import ImageCropper from "../../../../UI/Settings/CPSettingUploadImage/ImageCropper";

import './styles.scss';

const FILE_MAX_SIZE = 20971520;
const ALLOWED_FILE_TYPES = ['image/png', 'image/jpeg', 'image/bmp', 'image/heif', 'image/heic'];
const DEFAULT_PHOTO_PATH = '/player/images/avatar.svg';

const ParticipantPhoto = ({ image, onChange }) => {
    const [photoUrl, setPhotoUrl] = useState('');
    const [previewUrl, setPreviewUrl] = useState('');
    const [isModalVisible, setModalVisible] = useState(false);
    const [error, setError] = useState('');
    const photoInputRef = useRef();

    useEffect(() => {
        setPreviewUrl(image ?? DEFAULT_PHOTO_PATH);
    }, [image]);

    const handleUploadPhoto = () => {
        const file = photoInputRef.current?.files[0];

        if (!file) {
            return;
        }

        if (file.size > FILE_MAX_SIZE) {
            setError('Вес файла не должен превышать 20мб');
            return;
        }

        if (!ALLOWED_FILE_TYPES.includes(file.type)) {
            setError('Необходимый формат файла – png, jpg или bmp');
            return;
        }

        setError('');
        setPhotoUrl(URL.createObjectURL(file));
        setModalVisible(true);
    };

    const handleSavePhoto = async (url) => {
        const base64Response = await fetch(url);
        const blob = await base64Response.blob();
        const file = new File(
            [blob],
            `fileName.jpeg`,
            {
              type: 'image/jpeg',
              lastModified: new Date(),
            }
        );

        setPreviewUrl(url);
        onChange(PARTICIPANT_PHOTO, file);
        setModalVisible(false);
    };

    const handleDeletePhoto = () => {
        setPreviewUrl(DEFAULT_PHOTO_PATH);
        onChange(PARTICIPANT_PHOTO, 'DELETE');
    };

    return (
        <>
            <FormGroup className="participant-photo">
                <FormGroup>
                    <div>
                        <img
                            src={previewUrl}
                            onClick={() => photoInputRef.current.click()}
                            alt={''}
                            className="participant-photo__image"
                        />
                    </div>
                    <FormControl
                        type="file"
                        inputRef={ref => photoInputRef.current = ref}
                        onChange={handleUploadPhoto}
                        style={{display: 'none'}}
                    />
                </FormGroup>
                <p className="participant-photo__buttons">
                    <Button
                        disabled={!previewUrl}
                        onClick={() => photoInputRef.current.click()}
                    >
                        Изменить
                    </Button>
                    <Button
                        disabled={!previewUrl}
                        onClick={handleDeletePhoto}
                    >
                        Удалить
                    </Button>
                </p>
                {error && (
                    <p className="participant-photo__error">
                        * {error}
                    </p>
                )}
            </FormGroup>

            <ImageCropper
                isModalVisible={isModalVisible}
                imageUrl={photoUrl}
                fixtedCropper
                cropperWidth={500}
                cropperHeight={500}
                onSave={handleSavePhoto}
                onClose={() => setModalVisible(false)}
            />
        </>
    );
};

export default ParticipantPhoto;
